import { TESTING_EQUIPMENT_SEARCH_START_LOADING, TESTING_EQUIPMENT_SEARCH_END_LOADING, TESTING_EQUIPMENT_SEARCH_LOADED, SET_TESTING_EQUIPMENT_FILTER } from "../constants/IneTestingEquipmentConstants";
import { TESTING_EQUIPMENT_START_LOADING, TESTING_EQUIPMENT_END_LOADING, TESTING_EQUIPMENT_LOADED } from "../constants/IneTestingEquipmentConstants";

import { getApiData, postApiJsonData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadTestingEquipmentSearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TESTING_EQUIPMENT_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("TestingEquipment/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: TESTING_EQUIPMENT_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TESTING_EQUIPMENT_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TESTING_EQUIPMENT_SEARCH_END_LOADING });
        }
    };
}

export function setTestingEquipmentFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_TESTING_EQUIPMENT_FILTER,
            payload: filter
        });
    };
}

export function loadTestingEquipment(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TESTING_EQUIPMENT_START_LOADING });

        try {

            var data = await getApiData("TestingEquipment/GetTestingEquipmentFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: TESTING_EQUIPMENT_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TESTING_EQUIPMENT_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TESTING_EQUIPMENT_END_LOADING });
        }
    };
}

export function saveTestingEquipment(fbo, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TESTING_EQUIPMENT_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("TestingEquipment/SaveTestingEquipmentFBO", null, fbo);
            
            if(data.success) {
                if(isAdd) {
                    navigate('/ine-equipment-edit/' + data.responseEntities[0].testingEquipment.id);
                    dispatch(commonActions.setSuccessMessage("Equipment Created Successfully!"));
                }
                else {
                    await dispatch({
                        type: TESTING_EQUIPMENT_LOADED,
                        payload: data.responseEntities[0]
                    });

                    dispatch(commonActions.setSuccessMessage("Equipment Saved Successfully!"));
                }
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TESTING_EQUIPMENT_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TESTING_EQUIPMENT_END_LOADING });
        }
    };
}